import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import I18n from 'PMT/i18n/I18n';

// -- entities
import { Order } from 'PMT/entities/order';

// -- views
import { Modal } from 'react-bootstrap';
import OrderDetailView from './OrderDetailView';

/**
 * @parent Layout.js
 */
export default class OrderDetailModal extends Component {

  static propTypes = {
    show: PropTypes.bool.isRequired,

    onHide: PropTypes.func.isRequired,

    order: PropTypes.instanceOf(Order).isRequired,

    currencyCode: PropTypes.string,

  };

  shouldComponentUpdate(nextProps: Object) {
    return nextProps.show !== this.props.show;
  }

  // -- events - modal

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  // -- renderers

  renderBody() {
    return (
      <OrderDetailView
        order={this.props.order}
        onHide={this.props.onHide}
        currencyCode={this.props.currencyCode}
      />
    );
  }

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {I18n.tr('components.order.detail.order_detail')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }
}
